import Loading from 'quasar/src/plugins/loading/Loading.js';
import { FindFileItemCommand, FindFilesInfoCommand } from "src/api/Common/Commands/FindFilesInfoCommand";
import { FileHelper } from "src/extensions/utils/FileHelper";
import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import { api } from "~/api";
import { GetFilesCommand } from "~/api/Common/Commands/GetFilesCommand";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { FileCode, FileFetchKb, JokyoKb, PageID } from "~/extensions/utils/DefineTypes";
import { store as taikyoStore } from "~/pages/taikyo/store/TaikyoStore";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
const log = Log.create("TaikyoNotificationFlowGuide");
export default defineComponent({
    name: "TaikyoNotificationFlowGuidePage",
    components: {
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        if (myPageStore.isMultipleKeiyaku) {
            const fromScreen = from.name;
            const relatedScreens = ["taikyo-room-list", "taikyo-precaution"];
            if (relatedScreens.includes(fromScreen)) {
                next();
                return;
            }
            next({ name: "taikyo" });
            return;
        }
        next();
    },
    setup() {
        const router = useRouter();
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const pageName = commonStore.pageName(PageID.taikyoNotificationFlowGuide);
        // フロー表示
        const flowItems = reactive({
            items: []
        });
        const html = reactive({ value: "" });
        // ダウンロード表示用の対象入居者
        const tenants = myPageStore.personal.nyukyokeiyakuList.filter(x => taikyoStore.notFoundNyukyoList.includes(x.orgNyukyokeiyakuNo));
        // ファイル関連
        const findFilesInfoCommand = new FindFilesInfoCommand();
        const getFilesCommand = new GetFilesCommand();
        // 初期表示処理
        const initView = async () => {
            try {
                if (taikyoStore.selectRoomSb === null) {
                    taikyoStore.roomSbCheck(taikyoStore.selectedRooms.map(x => x.roomSb));
                }
                // 退去通知の流れメッセージ取得APIリクエスト
                html.value = await api.taikyoNotification.loadFlowGuideText();
                // 退去通知の流れリスト取得APIリクエスト
                flowItems.items = await api.taikyoNotification.getFlowGuideItems();
            }
            catch (ex) {
                log.error("setup", ex);
                MsgBox.error(ex.message);
            }
        };
        // ファイル関連処理
        const downloadFileByCode = async () => {
            try {
                // ローディング表示
                Loading.show();
                // ファイル情報取得パラメータ設定
                findFilesInfoCommand.fileList = [new FindFileItemCommand(FileFetchKb.Server, FileCode.TaikyoHasonTemplateFile)];
                // ファイル情報取得
                const checkResult = await api.common.findFilesInfo(findFilesInfoCommand);
                // ファイル取得
                const target = checkResult.fileList.find(x => x.fileCode === FileCode.TaikyoHasonTemplateFile);
                // ファイル未存在
                if (!target?.fileExists) {
                    await MsgBox.error(commonStore.messages.PE0001);
                    return;
                }
                // ファイル取得パラメータ設定
                getFilesCommand.fileList = [
                    {
                        fileNo: target.fileNo,
                        fileFetchKb: FileFetchKb.Server,
                        fileCode: target.fileCode,
                        fileExists: target.fileExists
                    }
                ];
                // ファイル取得
                const zipBlob = await api.common.getFiles(getFilesCommand);
                // Zip内からファイル取得
                const fileData = await FileHelper.getFileFromZip(zipBlob, target.fileNo);
                // ZIP内未存在
                if (!fileData) {
                    await MsgBox.error(commonStore.messages.PE0001);
                    return;
                }
                // ダウンロード
                FileHelper.downloadBlob(fileData.blob, fileData.fileName);
            }
            catch (ex) {
                // エラー表示
                await MsgBox.error(ex.data.errorMessage);
            }
            finally {
                // ローディング非表示
                Loading.hide();
            }
        };
        const onClick = async () => {
            if (taikyoStore.taikyoEntity.status === 0 && myPageStore.selectedNyukyokeiyaku.jokyoKb !== JokyoKb.MoveIn) {
                await MsgBox.error(commonStore.messages.PE0001);
                router.push({ name: "top" });
                return;
            }
            router.push({ name: "taikyo-notification-flow-next" });
        };
        initView();
        return {
            html,
            flowItems,
            isMultipleKeiyaku,
            pageName,
            PageID,
            tenants,
            taikyoStore,
            downloadFileByCode,
            onClick
        };
    }
});
